import Block from '@/components/Block'
import { GsuHTMLEmbed } from '@/compositions/GsuHTMLEmbed'
import { GlobalMetaTags } from '@/compositions/MetaInfo'
import PageLayout from '@/compositions/PageLayout'
import { getConfig } from '@/lib/config'
import { GetServerSideProps, NextPage } from 'next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'

const { publicRuntimeConfig } = getConfig()

const SupportDiscoverPage: NextPage = () => {
  const { partnerId, page } = publicRuntimeConfig?.gsuHTMLEmbeds.support
  return (
    <PageLayout>
      <GlobalMetaTags title="Support" description="Contains Support articles and videos" />
      <Block theme="white">
        <GsuHTMLEmbed partnerId={partnerId} page={page} />
      </Block>
    </PageLayout>
  )
}

export const getServerSideProps: GetServerSideProps = async ({ locale = 'en-US' }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale, ['common', 'classes'])),
      disableAuthPrompt: true,
    },
  }
}

export default SupportDiscoverPage
